module.exports = __webpack_public_path__ + "img/default-hd.42d3d7cb.png";